import axios from 'axios'

/**
 * 棋牌对战相关API
 */
export default {
  /**
   * 创建房间
   */
  createRoom(userId, gameType, maxPlayers) {
    return axios({
      url: '/message/api/v1/game/create',
      method: 'post',
      params: { userId },
      data: { gameType, maxPlayers }
    })
  },

  /**
   * 通过房间码加入房间
   */
  joinRoom(userId, roomCode) {
    return axios({
      url: '/message/api/v1/game/join',
      method: 'post',
      params: { userId, roomCode }
    })
  },

  /**
   * 离开房间
   */
  leaveRoom(userId, roomId) {
    return axios({
      url: '/message/api/v1/game/leave',
      method: 'post',
      params: { userId, roomId }
    })
  },

  /**
   * 获取房间信息
   */
  getRoomInfo(roomId) {
    return axios({
      url: `/message/api/v1/game/room/${roomId}`,
      method: 'get'
    })
  },

  /**
   * 开始游戏(房主)
   */
  startGame(userId, roomId) {
    return axios({
      url: '/message/api/v1/game/start',
      method: 'post',
      params: { userId, roomId }
    })
  },

  /**
   * 获取玩家手牌(断线重连或延迟加入)
   */
  getPlayerHand(roomId, userId) {
    return axios({
      url: `/message/api/v1/game/hand/${roomId}`,
      method: 'get',
      params: { userId }
    })
  },

  /**
   * 邀请好友加入房间
   */
  inviteToRoom(userId, roomId, friendId) {
    return axios({
      url: '/message/api/v1/game/invite',
      method: 'post',
      params: { userId, roomId, friendId }
    })
  }
}
